module.exports = __webpack_public_path__ + "c06077e87cc91bfb71cb9034b8310e96.pdf";